import { SideMenuDrawer } from './SideMenuDrawer';
import type { ReactNode } from 'react';

interface MobileSideMenuProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}

export default function MobileSideMenu({ open, onClose, children }: MobileSideMenuProps) {
  return (
    <SideMenuDrawer variant="temporary" open={open} onClose={onClose} drawerWidth={240}>
      {children}
    </SideMenuDrawer>
  );
}
